import { put, call, all, takeEvery, delay, select } from "redux-saga/effects";
import commonActions from "../common/actions";
import candidatesActions from "./actions";
import objectionTrackActions from "./actions";
import axios from "axios";
import { API_URL } from "../../utils/constants";
import masterActions from "../master/action";
import authActions from "../auth/actions";
import Cookies from "js-cookie";
import { calculateDaysDifference, formatDate } from "../../utils/validations";
import {
  EncryptFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import {
  handleDecodeJSON,
  handleEncodeJson,
} from "../../utils/encodeDecodeJson";

const objectionTrackerSaga = function* () {
  yield all([
    yield takeEvery(
      objectionTrackActions.GET_OBJECTION_COURSES,
      getObjectionCourses
    ),
    yield takeEvery(
      objectionTrackActions.RAISE_OBJECTION_DETAILS_CREATION,
      raiseObjectionDetailsCreation
    ),
    yield takeEvery(
      objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,
      getCandidateObjectionDetails
    ),
    yield takeEvery(
      objectionTrackActions.GET_OBJECTION_DELETE,
      DeleteCandidateObjectionDetails
    ),
    yield takeEvery(
      objectionTrackActions.RAISE_OBJECTION_BUTTON_CLICK,
      RaiseObjectionButtonClick
    ),

    yield takeEvery(objectionTrackActions.GET_OBJ_CREDENTIAL, getObjCredential),
    yield takeEvery(
      objectionTrackActions.GET_OBJ_QUESTIONS,
      getObjQuestionData
    ),
  ]);
};

const getObjectionCourses = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/objectiontrack-courses/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    yield put({
      type: objectionTrackActions.SET_OBJECTION_COURSES,
      payload: decryptedData,
    });
  } catch (err) {}
};

const raiseObjectionDetailsCreation = function* (data) {
  const { payload } = data;
  const { resetForm } = payload;

  const formData = new FormData();
  let { docurl, questiondetails, handleCloseDialog, ...formDatas } =
    payload?.data;

  for (let key in formDatas) {
    formData.append(key, payload?.data[key]);
  }

  if (payload?.data?.docurl?.file !== null) {
    const file = new File(
      [payload?.data?.docurl],
      payload?.data?.docurl?.name,
      { type: payload?.data?.docurl?.type }
    );
    formData.append("docurl", file);
  }
  const b64 =
    payload?.data?.questiondetails?.question?.props?.children[0]?.props?.src;

  if (b64) {
    const byteCharacters = atob(b64.split(",")[1]);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const byteArray = new Uint8Array(byteNumbers);
    const blob = new Blob([byteArray], { type: "image/png" });

    const file = new File([blob], "question_image.png", { type: "image/png" });

    formData.append("questiondetails", file);
  }

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: true });

  try {
    const result = yield call(() =>
      axios.post(`${API_URL}/raiseobjection`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
    );

    yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,
      payload: {
        candidateid: payload?.data?.candidateid,
        courseid: payload?.data?.courseid,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });

    if (result?.data?.statusCode === 200) {
      yield delay(1000);
      handleCloseDialog();
      resetForm();
    }
  } catch (err) {}

  yield put({ type: commonActions.SET_BUTTON_LOADER, payload: false });
};

const getCandidateObjectionDetails = function* (data) {
  const { payload } = data;
  const { candidateid, courseid } = payload;
  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);

  try {
    if (candidateid && courseid) {
      const result = yield call(() =>
        axios.get(
          `${API_URL}/candidate/obj-details/${encodeURIComponent(
            EncryptFunction(candidateid)
          )}/${encodeURIComponent(EncryptFunction(courseid))}`
        )
      );
      const decryptedData = yield call(handleDecodeJSON, {
        decodeJSON: result?.data?.encryptedData,
      });
      yield put({
        type: objectionTrackActions.SET_CANDIDATE_OBJECTION_DETAILS,
        payload: decryptedData,
      });
    }
  } catch (err) {}
};

const DeleteCandidateObjectionDetails = function* (data) {
  const { payload } = data;

  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  try {
    const result = yield call(() =>
      axios.delete(
        `${API_URL}/delete-objection/${encodeURIComponent(
          EncryptFunction(payload.objectionquestionid)
        )}`
      )
    );

    yield put({
      type: objectionTrackActions.SET_OBJECTION_DELETE,
      payload: result?.data.result,
    });

    yield put({
      type: commonActions.SET_ALERT,
      payload: {
        status: result?.data?.statusCode === 200 ? "success" : "failed",
        show: true,
        message: result?.data?.message,
      },
    });

    yield put({
      type: objectionTrackActions.GET_CANDIDATE_OBJECTION_DETAILS,
      payload: {
        candidateid: payload?.candidateid,
        courseid: payload?.courseid,
      },
    });

    yield delay(2000);
    yield put({
      type: commonActions.SET_ALERT,
      payload: { status: null, show: false, message: null },
    });
  } catch (err) {}
};

const RaiseObjectionButtonClick = function* (data) {
  const { payload } = data;

  yield put({ type: authActions.CANDIDATE_TOKEN_VERIFY });
  yield delay(1000);
  try {
    const result = yield call(() =>
      axios.post(
        `${API_URL}/raise-objection-click/${encodeURIComponent(
          EncryptFunction(payload?.candidateid)
        )}/${encodeURIComponent(EncryptFunction(payload?.courseid))}`,
        {
          click: payload?.click,
          obj_data: payload?.objectionDetails,
          objectionId: payload?.objectionId,
        }
      )
    );
  } catch (err) {}
};

const getObjCredential = function* (data) {
  const { payload } = data;
  try {
    const result = yield call(() =>
      axios.get(
        `${API_URL}/obj-credential/${encodeURIComponent(
          EncryptFunction(payload?.courseid)
        )}`
      )
    );
    const decryptedData = yield call(handleDecodeJSON, {
      decodeJSON: result?.data?.encryptedData,
    });
    yield put({
      type: objectionTrackActions.SET_OBJ_CREDENTIAL,
      payload: decryptedData,
    });
  } catch (err) {}
};

const getObjQuestionData = function* (action) {
  const { token } = action.payload;

  try {
    const result = yield call(() =>
      axios.post(
        `https://geni-dev.hubblehox.ai/api/project/objection-tracker`,
        {
          page: 1,
          limit: 10,
        },
        {
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        }
      )
    );
    const responseData = result.data;

    if (responseData.code === "OK") {
      yield put({
        type: objectionTrackActions.SET_OBJ_QUESTIONS,
        payload: responseData.data,
      });
    } else {
      throw new Error(responseData.message || "API request failed");
    }
  } catch (err) {
    console.error("Error in getObjQuestionData:", err);
  }
};

export default objectionTrackerSaga;
